<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Drafts',
              value: 'drafts',
              icon: {
                inactive: require('@/assets/icons/draft-gray.svg'),
                active: require('@/assets/icons/draft-green.svg')
              }
            },
            {
              title: 'Incoming',
              value: 'incoming',
              icon: {
                inactive: require('@/assets/icons/incoming-gray.svg'),
                active: require('@/assets/icons/incoming-green.svg')
              }
            },
            {
              title: 'Outgoing',
              value: 'outgoing',
              icon: {
                inactive: require('@/assets/icons/outgoing-gray.svg'),
                active: require('@/assets/icons/outgoing-green.svg')
              }
            },
          ]" @change="switchTab"></widgetTabs>

        </div>
      </div>
      <div class="panel-wrapper-body">
        <div class="panel-wrapper-body-container">
          <div class="sent-email-item" v-for="(item, index) in notifications" :key="index" @click="selectItem(item)"
            :class="{
              active:
                selected_item_details && item.id === selected_item_details.id,
            }">
            <div class="sent-email-item-header">
              <div class="sent-email-item-header-profile">
                <widgetProfile :showContent="false" title="Dennis Nedry" :subtitle="''" :file_name="null"
                  :path="$fullUrl('images/profiles/')" :size="40" :text_size="14"></widgetProfile>
              </div>
              <div class="sent-email-item-header-title">Dennis Nedry commented...</div>
            </div>
            <div class="sent-email-item-body">
              <div class="sent-email-item-body-text">
                “Oh, I finished de-bugging the phones, but the system's compiling...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="email-draft-preview">
      <!-- Tab content details for email -->
      <div class="tab-content-details" v-if="selected_item_details">
        <div class="tab-content-details-header">
          <div class="tab-content-details-header-left-panel">
            <div class="email-user-profile">
              <widgetProfile :title="selected_item_details.name" :subtitle="''" :file_name="null"
                :path="$fullUrl('images/profiles/')" :size="40" :text_size="14"></widgetProfile>
            </div>
          </div>
          <div class="tab-content-details-options row">
            <dropdown-menu>
              <ul>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this email?" yesText="Delete"
                    noText="Cancel" @onComfirm="deleteOutboxEmail(selected_item_details)">
                    <a>Delete Email</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <div class="email-subject">
          {{ selected_item_details.subject }}
        </div>
        <div class="tab-content-details-body" v-html="selected_item_details.message"></div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="Select Notification"
          content="Select notification from the list to view information here" align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>
  
<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      activeTab: 3,
      selected_item_details: null,
      loading_page_data: false,
      notifications: [],
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("IncomingNotificationReflesh", () => {
      vm.getOutgoinfNotification();
    });
    vm.getOutgoinfNotification();

  },
  computed: {},
  watch: {},
  methods: {
    getOutgoinfNotification() {
      let vm = this;
      vm.$store
        .dispatch("COMMUNICATION_NOTIFICATION_GET_OUTGOING", {
          phase: vm.phase
        })
        .then((responce) => {
          vm.notifications = responce.data;
        })
        .catch((error) => { });
    },
    switchTab(tab) {
      let vm = this;
      if (tab.value == "drafts") {
        vm.activeTab = 1;
      } else if (tab.value == "incoming") {
        vm.activeTab = 2;
      } else if (tab.value == "outgoing") {
        vm.activeTab = 3;
      }
      vm.$emit("switchTab", vm.activeTab);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },

  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: calc(100% - 330px);
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 282px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        width: 100%;

        .tabs-widget {
          display: flex;
          width: 100%;

          .tabs-item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            cursor: pointer;

            .tabs-item-icon {
              margin-right: 5px;
              display: flex;
              align-items: center;
              height: 100%;

              img {
                width: 14px;
              }

              .active-icon {
                display: none;
              }
            }

            .tabs-item-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              color: #707070;
            }

            &.active,
            &:hover {
              .tabs-item-title {
                color: #1ba5a4;
              }

              .tabs-item-icon {
                .inactive-icon {
                  display: none;
                }

                .active-icon {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 50px);
      overflow-y: auto;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        padding-bottom: 10px;

        .sent-email-item {
          padding: 6px 6px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .sent-email-item-header {
            display: flex;
            margin-bottom: 5px;
            align-items: center;

            .sent-email-item-header-profile {
              margin-right: 5px;
              margin-bottom: 10px;

            }

            .sent-email-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 19px;
              color: #1c1c1c;
            }
          }

          .sent-email-item-body {
            .sent-email-item-body-text {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 11px;
              color: #8e8b8b;
              overflow: hidden;
              display: block;
              max-height: 4rem;
              -webkit-line-clamp: 2;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
            }
          }
        }
      }
    }
  }

  .email-draft-preview {
    width: calc(100% - 282px);
    height: 100%;
    border-radius: 5px;
    margin-left: 5px;

    .tab-content-details {
      width: 100%;
      height: max-content;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 0px 15px;
      padding-bottom: 80px;

      .tab-content-details-header {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tab-content-details-header-left-panel {
          .email-user-profile {
            margin-bottom: 10px;
          }
        }

        .tab-content-details-options {
          display: flex;
          align-items: center;
        }
      }

      .email-subject {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        color: #1c1c1c;
        margin-bottom: 10px;
      }

      .tab-content-details-body {
        padding: 15px;
        background: #fafafa;
        border-radius: 10px;
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
      border-radius: 5px;
    }
  }
}
</style>

  

  